import lodash from 'lodash';

import type { NormalizationProcessor, RicosContentBlock, RicosInlineStyleRange } from '../types';

/**
 * fixAtomicBlockText
 * @description sets whitespace as atomic block text
 */
export const fixAtomicBlockText: NormalizationProcessor<RicosContentBlock> = block =>
  block.type === 'atomic' ? { ...block, text: ' ' } : block;

/**
 * addInlineStyleRanges
 * @description ensures that block.inlineStyleRanges is defined ([] by default)
 */
export const addInlineStyleRanges: NormalizationProcessor<RicosContentBlock> = block => ({
  ...block,
  inlineStyleRanges: block.inlineStyleRanges || [],
});

/**
 * fixLinkUnderlineRange
 * @description adds underline inline style ranges to links
 */
export const addLinkUnderlineRange: NormalizationProcessor<RicosContentBlock> = (
  block,
  range: RicosInlineStyleRange
) => {
  const inlineStyleRange = {
    offset: range.offset,
    length: range.length,
    style: 'UNDERLINE',
  };

  const inlineStyleRanges = lodash.uniqWith(
    [...(block.inlineStyleRanges || []), inlineStyleRange],
    lodash.isEqual
  );

  return { ...block, inlineStyleRanges };
};

const isHexColor = (str: string) => /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i.test(str);

const wrapTextColorStyle = (style: string) =>
  isHexColor(style) ? JSON.stringify({ FG: style }) : style;

/**
 * fixTextColorStyle
 * @description fixes legacy text color format from '#XXXXXX' to '{FG: #XXXXXX}'
 */
export const fixTextColorStyle: NormalizationProcessor<RicosContentBlock> = block => {
  return {
    ...block,
    inlineStyleRanges: block.inlineStyleRanges.map(range => ({
      ...range,
      style: wrapTextColorStyle(range.style),
    })),
  };
};
